module.exports = __webpack_public_path__ + "img/bathroom-outline-icon.6ed4739a.svg";